import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormArray, FormGroup } from '@angular/forms'
// import { LineOtherIncomeComponent } from '../line-other-income/line-other-income.component';
import { AddMaslolComponent } from '../add-maslol/add-maslol.component';

@Component({
  selector: 'app-internal-maslol-array',
  templateUrl: './internal-maslol-array.component.html',
  styleUrls: ['./internal-maslol-array.component.scss']
})
export class InternalMaslolComponent implements OnInit {

	@Input() public internalMaslolArray: FormArray;
	@Input() public displayErrors: boolean;
	@Input() public titles: string[];
	@Output() onAddFormGroup: EventEmitter<any> = new EventEmitter<any>();
	// @Input() public tiknumType;
	@Output() onMaslolChange: EventEmitter<any> = new EventEmitter<any>();
	@Input() public ph: string[];
	@Input() public buttons: string[];
	@Input() public qID: string;

	maxMaslolArrayLength = 4;


  constructor() { }

  	ngOnInit() {
	}

	emitMaslolChanges($event) {
	this.onMaslolChange.emit($event);
	}

	addMaslol() {
		this.onAddFormGroup.emit();
		this.displayErrors = this.internalMaslolArray.invalid;
			if (this.internalMaslolArray.valid)
			{
				this.internalMaslolArray.push(AddMaslolComponent.buildMaslol(''));
			}
	}

	simulateClick(event) {
		if ( event.keyCode === 13 ){
		  event.currentTarget.click();
		} 
	 }

  
	static buildMaslol(value:any) {
		let arr: FormGroup[]=[];
		if(value && value[0][0].answerValue) {
			value.forEach(element => {
				arr.push(AddMaslolComponent.buildMaslol(element));
			});
		}
		else{
			arr.push(AddMaslolComponent.buildMaslol(''));
		}
		return new FormArray(arr);
  }
}



// WEBPACK FOOTER //
// ./src/app/internal-maslol-array/internal-maslol-array.component.ts